export default __webpack_public_path__ + "static/media/portfolio.ff543d49.PNG";